import { AfterViewInit, Component, ElementRef, inject, input, output, signal, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { CommonButtonRowWidget } from '../../../../ui/widgets/buttons/common-button-row.widget';
import { BootstrapDialogAction } from '../../bootstrap-dialog-action';


@Component({
	selector: 'dialog-frame',
	standalone: true,
	imports: [CommonButtonRowWidget],
	templateUrl: './bootstrap-dialog.frame.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	host: {
		'[class.modal-content]': 'true'
	}
})

export class BootstrapDialogFrame implements AfterViewInit {

	private readonly router = inject(Router);

	public readonly icon = input<string>('fa-info-circle');
	public readonly header = input<string>('Header');
	public readonly modalBodyPaddingZero = input<boolean>(false);
	public readonly actions = input<BootstrapDialogAction[]>([]);

	public readonly actionClick = output<BootstrapDialogAction<unknown>>();
	public readonly closed = output<BootstrapDialogAction<unknown> | undefined>();

	public readonly handlingClick = signal(false);
	public formSubmitButton = viewChild.required<ElementRef<HTMLButtonElement>>('saveBtn');

	async click(action: BootstrapDialogAction<unknown>) {
		this.handlingClick.set(true);

		//
		// perform the action
		//
		if (action.linkType == 'routerLink') {
			this.router.navigate([action.url]);
		}

		else if (action.linkType == 'href') {
			//
			// Nothing to do. The a[href] will handle
			// the navigation
			//
		}

		else if (action.linkType == 'callback') {
			this.handlingClick.set(false);
			action.callbackResult = action.callback ? (await action.callback()) ?? action.callbackResult : action.callbackResult;
		}

		else if (action.linkType == 'actionClick-event') {
			this.actionClick.emit(action);
		}


		//
		// close the dialog
		//
		if (action.willCloseDialog) {
			this.closed.emit(action);
		}

		this.handlingClick.set(false);
	}

	ngAfterViewInit() {
		if (this.actions().length) {
			const action = this.actions().find(a => a.id === 'common-form-submit');
			if (action) {
				if (action.commonForm) {
					action.commonForm!.setSubmitButton(
						this.formSubmitButton(),
						async () => {
							if (action.callback) await action.callback();
						});
				} else {
					console.error('No common form found in dialog action with id "submit"');
				}
			}
		}
	}
}
